import cx from 'classnames';

import s from './PostBookingSurveyConfirmation.module.css';

type Props = {
  hasForms?: boolean;
  onConfirm: () => void;
  ariaLabels?: string;
};

export const PostBookingSurveyConfirmation = ({
  hasForms = false,
  onConfirm,
}: Props) => {
  return (
    <>
      <p className={s.text}>
        {hasForms
          ? `Don’t forget to complete your form prior to our appointment. `
          : `Don’t forget to add your appointment to your calendar. `}
        See you soon!
      </p>
      <button
        type="button"
        className={cx('brand-primary-color', s.confirmButton)}
        onClick={onConfirm}
      >
        Ok
      </button>
    </>
  );
};
